import { Loader2, LogOut, RefreshCw } from "lucide-react";
import { DiscoLogo } from "./DiscoLogo";

export default function TopBar({ session, syncing, onSync, onLogout }) {
  return (
    <header className="sticky top-0 z-20 flex items-center justify-between px-6 py-4 backdrop-blur-[2px]">
      <div className="md:hidden flex items-center gap-2">
        <DiscoLogo size={30} />
        <span className="font-extrabold tracking-tight">Glimpse</span>
      </div>
      <div className="hidden md:block" />
      <div className="flex items-center gap-2">
        <button data-testid="sync-library-btn-mobile" onClick={onSync} className="md:hidden rounded-full bg-black/60 p-2">
          {syncing ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
        </button>
        <div className="flex items-center gap-2 rounded-full bg-black/60 p-1 pr-3">
          {session.image_url ? (
            <img src={session.image_url} alt="" className="h-7 w-7 rounded-full" />
          ) : (
            <div className="h-7 w-7 rounded-full bg-[#FF2E93] text-black flex items-center justify-center font-bold text-sm">
              {session.display_name?.[0] || "?"}
            </div>
          )}
          <span data-testid="user-name" className="text-sm font-bold">{session.display_name}</span>
        </div>
        <button
          data-testid="logout-btn"
          onClick={onLogout}
          className="rounded-full bg-black/60 p-2 text-[#B3B3B3] hover:text-white"
          title="Se déconnecter"
        >
          <LogOut className="h-4 w-4" />
        </button>
      </div>
    </header>
  );
}
